<template>
    <div>
      <modal v-if="estimationInfo" :details="estimationDetails" :clientsId="{id:estimationInfo.client_id}" :tax="{taxIncluded:taxIncluded, taxRate:taxRate}"/><!-- VAT -->
      <nav aria-label='breadcrumb'>
          <ol class='breadcrumb'>
              <li class='breadcrumb-item'><a href='#'>{{translations('navbar.sale_management')}}</a></li>
              <li class='breadcrumb-item'><router-link to='/archive-estimates'>{{translations('estimate.archive_estimate')}}</router-link></li>
              <li class='breadcrumb-item active' aria-current='page'>{{translations('estimate.estimate_detail')}}</li>
          </ol>
      </nav>
      <div class='container-fluid main-container'>
          <div class='d-flex flex-wrap'>
              <div v-if="estimationInfo" class='left-container'>
              <div class='form-inline mb-4'>
                  <div class='form-group mr-2'>
                      <button v-if="Number(estimationInfo.estimation_status) === 1" @click="approveEstimate()" class='btn btn-primary'>{{translations('estimate.order_processing')}}</button>
                      <strong v-else-if="Number(estimationInfo.estimation_status) === 2" class="text-primary">{{translations('estimate.ordered')}}</strong>
                      <strong v-else-if="Number(estimationInfo.estimation_status) === 3" class="text-danger">{{translations('estimate.lost_order')}}</strong>
                  </div>
              </div>
              <h5 class='mb-3'>Information</h5>
              <table class='table table-sm table-borderless table-information'>
                  <tbody>
                      <tr>
                          <th>{{translations('estimate.estimated_at')}}</th>
                          <td>
                              <button ref="info01" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info01' data-placement='right'>{{ estimationInfo.estimated_at ? formatDateAt(estimationInfo.estimated_at) : '--------------' }}</button>
                              <div id='popover-info01' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.estimated_at')}}</div>
                                  <div class='popover-body popover-content'>
                                    <input type='date' v-model="temp.estimated_at" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                    <button type='submit' v-on:click="updateField('estimated_at', temp.estimated_at, 'info01')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.name')}}</th>
                          <td>
                              <button ref="info02" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info02' data-placement='right'>{{ estimationInfo.name ? estimationInfo.name : '--------------' }}</button>
                              <div id='popover-info02' class='popover popover-x popover-default resize'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.name')}}</div>
                                  <div class='popover-body popover-content'>
                                    <textarea v-model="temp.name" class='form-control horizontal-only' rows="1"></textarea>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('name', temp.name, 'info02')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.estimate_number')}}</th>
                          <td>{{estimationInfo.estimate_number}}</td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.supplier')}}</th>
                          <td>
                              <button ref="info04" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info04' data-placement='right'>{{ estimationInfo.client.name ? estimationInfo.client.name : '--------------' }}</button>
                              <div ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.supplier')}}</div>
                                  <div class='popover-body popover-content'>
                                    <p style="position:absolute;left:-10000px">{{forcechange}}</p>
                                    <v-select :options="clients" label="name"  v-model="temp.client" @input="setSelectedClient"></v-select>
                                  </div>
                                  <div class='popover-footer'>
                                  <button type='submit'  v-on:click="updateField('client_id', temp.client, 'info04')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.destination_name')}}</th>
                          <td>
                              <button ref="info05" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info05' data-placement='right'>{{ estimationInfo.destination.name ? estimationInfo.destination.name : '--------------' }}</button>
                              <div ref="popover-info05" id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.destination_name')}}</div>
                                  <div class='popover-body popover-content'>
                                    <v-select :options="destinations" label="name" value="id"  @input="setSelectedClient2" v-model="temp.destination"></v-select>
                                  </div>
                                  <div class='popover-footer'>
                                  <button type='submit'  v-on:click="updateField('destination_id', temp.destination, 'info05')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.contact_person')}}</th>
                          <td>
                              <button ref="info06" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info06' data-placement='right'>{{ estimationInfo.end_user ? estimationInfo.end_user : '--------------' }}</button>
                              <div id='popover-info06' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.contact_person')}}</div>
                                  <div class='popover-body popover-content'>
                                      <input type='text' v-model="temp.end_user" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('end_user', temp.end_user, 'info06')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.delivery_time')}}</th>
                          <td>
                              <button ref="info07" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info07' data-placement='right'>{{ estimationInfo.quotation_delivery_time ? estimationInfo.quotation_delivery_time : '--------------' }}</button>
                              <div id='popover-info07' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.delivery_time')}}</div>
                                  <div class='popover-body popover-content'>
                                      <input type='text' v-model="temp.quotation_delivery_time" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('quotation_delivery_time', temp.quotation_delivery_time, 'info07')" class='btn btn-sm btn-primary'>OK</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.transaction_system')}}</th>
                          <td>
                              <button ref="info08" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info08' data-placement='right'>{{ estimationInfo.quotation_transaction_system ? estimationInfo.quotation_transaction_system : '--------------' }}</button>
                              <div id='popover-info08' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.transaction_system')}}</div>
                                  <div class='popover-body popover-content'>
                                      <input type='text' v-model="temp.quotation_transaction_system" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('quotation_transaction_system', temp.quotation_transaction_system, 'info08')" class='btn btn-sm btn-primary'>OK</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.expiry_date')}}</th>
                          <td>
                              <button ref="info09" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info09' data-placement='right'>{{ estimationInfo.quotation_expiration_date ? estimationInfo.quotation_expiration_date : '--------------' }}</button>
                              <div id='popover-info09' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.expiry_date')}}</div>
                                  <div class='popover-body popover-content'>
                                      <input type='text' v-model="temp.quotation_expiration_date" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('quotation_expiration_date', temp.quotation_expiration_date, 'info09')" class='btn btn-sm btn-primary'>OK</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.remarks')}}</th>
                          <td>
                              <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>{{ estimationInfo.memo ? estimationInfo.memo : '--------------' }}</button>
                              <div id='popover-info10' class='popover popover-x popover-default resize'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.remarks')}}</div>
                                  <div class='popover-body popover-content'>
                                      <textarea class="form-control" v-model="temp.memo"></textarea>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('memo', temp.memo, 'info10')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                          <th>{{translations('estimate.manager')}}</th>
                          <td>
                              <button ref="salesman_name" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-salesman_name' data-placement='right'>{{ estimationInfo.salesman_name ? estimationInfo.salesman_name : '--------------' }}</button>
                              <div id='popover-salesman_name' class='popover popover-x popover-default'>
                                  <div class='arrow'></div>
                                  <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.manager')}}</div>
                                  <div class='popover-body popover-content'>
                                      <input type='text' v-model="temp.salesman_name" class='form-control'>
                                  </div>
                                  <div class='popover-footer'>
                                      <button type='submit' v-on:click="updateField('salesman_name', temp.salesman_name, 'salesman_name')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr>
                        <th>{{translations('common.last_updated_by')}}</th>
                        <td>{{estimationInfo.updated_by}}</td>
                      </tr>
                      <tr>
                        <th>{{translations('common.last_update_time')}}</th>
                        <td>{{estimationInfo.updated_at}}</td>
                      </tr>
                  </tbody>
              </table>
              <hr>
              <div class='form-inline'>
                  <div class='form-group mr-2'>
                    <button v-if="Number(estimationInfo.estimation_status) === 1" @click="disapproveEstimate()" class='btn btn-danger'>{{translations('estimate.lost_order_processing')}}</button>
                  </div>
                  <div class='form-group'>
                    <a class='btn btn-link btn-sm text-danger' data-href='#' v-on:click.self="deleteEstimate()">{{translations('common.delete')}}</a>
                  </div>
              </div>
              </div>
              <div class='right-container'>
                <div class="form-inline justify-content-end"><!-- VAT -->
                  <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
                  <div v-else>{{translations('common.tax_excluded')}}</div>
                </div>
              <div class='table-scroll mb-4'>
                  <table class='table table-sm table-striped table-1100'>
                      <thead>
                          <tr>
                          <th></th>
                          <th>{{translations('estimate.jan_code')}}</th>
                          <th>{{translations('estimate.model')}}</th>
                          <th>{{translations('estimate.tax_classification')}}</th><!-- TAXSTATUS -->
                          <th>{{translations('estimate.quantity')}}</th>
                          <th>{{translations('estimate.unit_price')}}</th>
                          <th>{{translations('estimate.product_cost')}}</th>
                          <th>{{translations('estimate.remarks')}}</th>
                          <th>{{translations('estimate.unit_price_total')}}</th>
                          <th>{{translations('estimate.total_cost')}}</th>
                          <th>{{translations('estimate.total_profit')}}</th>
                          </tr>
                      </thead>
                      <tbody class="nowrap">
                          <tr v-for='(detail, i) in estimationDetails' :key='i'>
                              <td>
                                <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                              </td>
                              <td>{{ detail.jan_code }}</td>
                              <td>{{ detail.type_number }}</td>
                              <td>
                                <select
                                 :disabled="false"
                                  v-model="detail.taxclass_id"
                                  v-validate="'required'"
                                  data-vv-name="taxclass_id"
                                  data-vv-as="税区分"
                                  class="custom-select width-100-px"
                                  required>
                                  <option value="1">{{ translations('estimate.taxable_item') }}</option>
                                  <option value="2">{{ translations('estimate.not_applicable') }}</option>
                                </select>
                              </td><!-- TAXSTATUS -->
                              <td class="right">{{ Number(detail.quantity).toLocaleString() }}</td>
                              <td :class="Number(detail.unit_price) < Number(detail.row_price) ? 'red-color right' : 'right'">{{ toTaxFormat(detail, 'unit_price')  }}</td>
                              <!-- 製品原価は税抜 -->
                              <td class="right">{{toTaxFormat(detail, 'row_price') }}</td>
                              <td>{{ detail.remarks }}</td>
                              <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                              <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                              <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                          </tr>
                          <tr class='bg-lightgreen'>
                              <td>
                                  <button class='btn-change plus' type='button' data-toggle='modal' data-target='#EstimateDetailsModal'><i></i></button>
                              </td>
                              <td></td><!-- TAXSTATUS -->
                              <td></td><td></td><td></td><td></td><td></td><td></td>
                              <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                              <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                              <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
              <div class='form-inline'>
                  <div class='form-group mr-2'>
                  <button class='btn btn-sm btn-primary' @click="updateEstimate()">{{translations('common.update')}}</button>
                  </div>
                  <div class='form-group'>
                  <a @click="getPDF()" class='btn btn-link btn-sm decoration-underline' href='#'>{{translations('estimate.estimate_PDF_output')}}<i class='fas fa-external-link-alt'></i></a>
                  </div>
              </div>
              </div>
          </div>
      </div>
      <vue-element-loading :active="isLoading" :is-full-screen="true"/>
    </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import EstimateDetailsModal from '@/components/EstimateDetailsModal'
import { mapState } from 'vuex'

export default {
  name: 'SingleEstimate',
  prop: {},
  components: {
    VueElementLoading,
    modal: EstimateDetailsModal
  },
  data () {
    return {
      taxRate: 0,
      taxIncluded: false,
      estimationId: null,
      estimationInfo: null,
      estimationDetails: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      temp: [],
      destinations: [],
      paramUpdate: {
        estimate_id: this.estimationId,
        information: this.estimationInfo,
        details: this.estimationDetails
      },
      isLoading: true,
      forcechange: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    confirmationDeleteEstimateMessage () {
      return this.translations('estimate.delete_estimate')
    },
    confirmationLostEstimateMessage () {
      return this.translations('estimate.lost_estimate')
    },
    confirmationUpdateEstimateMessage () {
      return this.translations('estimate.update_estimate')
    },
    confirmationProcessEstimateMessage () {
      return this.translations('estimate.processing_estimate')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },
  watch: {
    estimationId (v) {
      this.paramUpdate.estimate_id = v
    },
    estimationInfo (v) {
      this.paramUpdate.information = v
    },
    estimationDetails: {
      handler (v) {
        let $this = this
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = $this.prepareDetails(d)
          }
        })
        this.paramUpdate.details = v
        this.estimationDetails = v
        this.calcGrandTotals()
      },
      deep: true
    },
    'estimationInfo.client_id': {
      handler: function (v, oldV) {
        console.log('estimationInfo.client_id: ', v)
        const cname = this.getClientName(v)
        this.estimationInfo.client.name = cname
        this.temp.client.name = cname
        if (oldV) {
          this.paramUpdate.information.destination_name = ''
          this.paramUpdate.information.destination_id = ''
        }
        this.listDestinations()
      },
      deep: true
    }
  },

  created () {
    console.log('SingleEstimate:created:this.$route.query: ', this.$route.query)

    if (!this.$route.query.estimate_id) {
      this.$router.replace('archive-estimates')
      return
    }

    this.$store.dispatch('Master/checkBillTo')
    this.estimationId = this.$route.query.estimate_id

    Promise.all([
      this.getEstimation()
    ]).then(() => {
      this.calcGrandTotals()
      this.popoverButtons()
      this.isLoading = false
    }).catch(error => {
      this.$toastr.error(error, this.translations('common.error'))
    })
  },
  mounted () {
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    setSelectedClient (value) {
      this.forcechange = !this.forcechange
      this.temp.client = value
    },
    setSelectedClient2 (value) {
      this.forcechange = !this.forcechange
      this.temp.destinations = value
    },
    getEstimation () {
      const self = this
      return this.$http.post(this.$api_url.estimate_details, { estimate_id: this.estimationId }).then(function (response) {
        const result = response.data
        if (result.status === true) {
          self.estimationId = result.estimation_id
          self.estimationInfo = result.information
          self.temp = result.information
          self.temp.division_type_select = result.information.division_type
          self.temp.client = {
            id: self.temp.client_id,
            name: self.temp.client_name
          }
          self.temp.destination = {
            id: self.temp.destination_id,
            name: self.temp.destination_name
          }
          self.temp.estimated_at = self.formatDateAt(result.information.estimated_at, 1)
          self.estimationDetails = result.details
          self.taxRate = result.information.tax_rate
          self.taxIncluded = result.information.tax_included
          return Promise.resolve()
        } else {
          return Promise.reject(new Error(this.translations('estimate.notice_get_quote_failed')))
        }
      }).catch(function (error) {
        console.log('SingleEstimate:getEstimation:catch(error): ', error)
        return Promise.reject(new Error(this.translations('estimate.notice_failed')))
      })
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { client_id: this.estimationInfo.client.id }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'SingleEstimate:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SingleEstimate:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
      }
    },
    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    formatDateAt (v, b = 0) {
      if (v) {
        if (v.indexOf('-') > 0) {
          const x = /-/gi
          return v.replace(x, '/')
        } else {
          if (b) return v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(6, 2)
          else if (v.indexOf('/') > 0) return v
          else return v.substr(0, 4) + '/' + v.substr(4, 2) + '/' + v.substr(6, 2)
        }
      }
    },

    prepareDetails (data, hasCost = false) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        data.total_profit_inctax = this.$util.getIncludeTax(data.total_profit, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.estimationDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    deleteEstimate () {
      this.$dialog.confirm(this.confirmationDeleteEstimateMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let params = {
              estimate_id: this.paramUpdate.estimate_id
            }
            let del = await this.$http.post(this.$api_url.delete_estimate, params)
            if (del.data && del.data !== 'null' && del.data.status === true) {
              this.$toastr.success(this.translations('estimate.notice_delete_quote_success'), this.translations('common.success'))
              this.$router.replace({ name: 'archive-estimates' })
            } else {
              this.$toastr.error(del.data.message, this.translations('common.error'))
            }

            setTimeout(() => { this.isLoading = false }, 1000)
          } catch (e) {
            console.log('error: ', e)
            this.isLoading = false
            this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
          }
        }).catch(function () { console.log('Clicked on cancel:') })
    },

    async __update () {
      // 備考の改行数をチェック
      if (this.paramUpdate.information.memo && this.paramUpdate.information.memo.split('\n').length > 5) {
        this.$toastr.error(this.translations('estimate.notice_enter_remark_line'), this.translations('common.error'))
        return false
      }
      this.isLoading = true
      try {
        let update = await this.$http.post(this.$api_url.update_estimate, this.paramUpdate)
        console.log('SingleEstimate:Update: ', update)
        if (update.data && update.data.status === true) {
          return true
        } else {
          console.log('response message: ', update.data.message)
          this.$toastr.error(update.data.message, this.translations('common.error'))
          return false
        }
      } catch (e) {
        console.log('error: ', e)
        this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
        return false
      }
    },

    updateEstimate () {
      if (this.estimationDetails.length === 0) {
        this.$toastr.warning(this.translations('estimate.notice_enter_details_line'))
        return
      }
      this.$dialog.confirm(this.confirmationUpdateEstimateMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          if (await this.__update() === true) {
            this.$toastr.success(this.translations('estimate.notice_success'), this.translations('common.error'))
          }

          this.isLoading = false
        })
    },

    approveEstimate () {
      let $this = this
      this.$dialog.confirm(this.confirmationProcessEstimateMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          try {
            let params = {
              estimate_id: this.paramUpdate.estimate_id
            }
            let estimate = await this.$http.post(this.$api_url.order_add_from_estimate, params)
            let $data = this.$invoiceTools.prepareResult(estimate.data, 'list', 'SingleEstimate:approveEstimate')
            if ($data.success === true) {
              this.$toastr.success(this.translations('estimate.notice_order_success'), this.translations('common.success'))
              this.estimationInfo.estimation_status = 2
            } else {
              setTimeout(() => { this.$toastr.error($data.data, this.translations('common.error')) }, 1000)
            }
          } catch (error) {
            console.log('SingleEstimate:approveEstimate:catch(error): ', error)
            this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
          }
        })
      setTimeout(() => {
        $this.isLoading = false
      }, 1000)
    },

    disapproveEstimate () {
      let $this = this
      this.$dialog.confirm(this.confirmationLostEstimateMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          try {
            let params = {
              estimate_id: this.paramUpdate.estimate_id
            }
            let estimate = await this.$http.post(this.$api_url.estimate_failure_to_receive, params)
            let $data = this.$invoiceTools.prepareResult(estimate.data, 'list', 'SingleEstimate:disapproveEstimate')
            if ($data.success === true) {
              this.$toastr.success(this.translations('estimate.notice_lost_success'), this.translations('common.success'))
              this.estimationInfo.estimation_status = 3
            } else {
              setTimeout(() => { this.$toastr.error($data.data, this.translations('common.error')) }, 1000)
            }
          } catch (error) {
            console.log('SingleEstimate:disapproveEstimate:catch(error): ', error)
            this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
          }
        })
      setTimeout(() => {
        $this.isLoading = false
      }, 1000)
    },

    getClientName (id) {
      let vname = ''
      let $this = this
      this.clients.forEach(function (v) {
        if (v.id === parseInt(id)) {
          vname = v.name
          $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          return true
        }
      })
      return vname
    },
    getDestinationName (id) {
      let vname = ''
      this.destinations.forEach(function (v) {
        if (v.id === parseInt(id)) {
          vname = v.name
          return true
        }
      })
      return vname
    },

    /**
     * @param field : estimate information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let that = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'estimated_at') {
          that.$refs[ref].innerText = '--------------'
        } else {
          that.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'client_id') {
        const cname = this.getClientName(value.id) // TAXSTATUS @IN
        that.$refs[ref].innerText = cname
        val = value.id
      } else if (field === 'destination_id') {
        const dname = this.getDestinationName(value.id)
        that.$refs[ref].innerText = dname
        val = value.id
      } else if (field === 'estimated_at') {
        const fDate = this.formatDateAt(value, 1)
        that.$refs[ref].innerText = fDate
        val = fDate
        // that.temp[field] = val
      } else {
        that.$refs[ref].innerText = value
        val = value
      }
      that.estimationInfo[field] = val
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.estimationDetails.splice(i, 1)
    },

    async getPDF () {
      this.isLoading = true
      try {
        let pdf = await this.$http.post(this.$api_url.getPDF, { estimate_id: this.estimationId })

        if (pdf.data && pdf.data.pdf) {
          let arrBuff = this.$invoiceTools.__b64ToArrayBuffer(pdf.data.pdf)
          const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
          const pdfFileURL = URL.createObjectURL(pdfFile)
          window.open(pdfFileURL)
        } else {
          console.log('response message: ', pdf.data.message)
          this.$toastr.error(pdf.data.message, this.translations('common.error'))
        }
      } catch (error) {
        console.log('error: ', error)
        this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
      }
      this.isLoading = false
    }
  }
}
</script>
